import { Card, CardBody, Col } from "reactstrap";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import { sliesOnlyData, sliesOnlyDataList } from "../../../../Data/BonusUi/Carousel";
import { dynamicImage } from "../../../../Utils";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";
import { SlideOnly } from "../../../../Utils/Constants";

const SlidesOnly = () => {
  return (
    <Col xl="6" xs="12">
      <Card>
        <CardHeaderCommon title={SlideOnly} span={sliesOnlyData} />
        <CardBody>
          <Swiper centeredSlides={true} autoplay={{ delay: 2500, disableOnInteraction: false }} modules={[Autoplay]}>
            {sliesOnlyDataList.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={dynamicImage(item.image)} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SlidesOnly;
